import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/logo_desktop.svg';
const _hoisted_1 = { class: "min-h-screen bg-gray-50" };
const _hoisted_2 = { class: "bg-white" };
const _hoisted_3 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" };
const _hoisted_4 = { class: "flex justify-between items-center h-16" };
const _hoisted_5 = {
    key: 0,
    class: "fixed inset-0 z-10 overflow-y-auto",
    "aria-labelledby": "modal-title",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_6 = { class: "flex items-end justify-center min-h-screen text-center sm:block sm:p-0" };
const _hoisted_7 = { class: "inline-block align-bottom bg-white w-full text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" };
const _hoisted_8 = { class: "bg-white w-full" };
const _hoisted_9 = { class: "px-6 pt-6 pb-4" };
const _hoisted_10 = { class: "flex justify-between items-center mb-8" };
const _hoisted_11 = { class: "space-y-6" };
const _hoisted_12 = { class: "space-y-2" };
const _hoisted_13 = { class: "space-y-2" };
const _hoisted_14 = { class: "space-y-2" };
const _hoisted_15 = { class: "mt-1 flex justify-center px-6 py-6 border-2 border-gray-300 border-dashed rounded-md hover:border-gray-400 transition-colors" };
const _hoisted_16 = { class: "space-y-2 text-center" };
const _hoisted_17 = { class: "text-sm text-gray-600" };
const _hoisted_18 = {
    for: "audio-file",
    class: "relative cursor-pointer text-tuk-orange hover:text-tuk-orange-dark"
};
const _hoisted_19 = {
    key: 0,
    class: "text-sm text-gray-600"
};
const _hoisted_20 = { class: "space-y-2" };
const _hoisted_21 = { class: "mt-1 flex justify-center px-6 py-6 border-2 border-gray-300 border-dashed rounded-md hover:border-gray-400 transition-colors" };
const _hoisted_22 = { class: "space-y-2 text-center" };
const _hoisted_23 = { class: "text-sm text-gray-600" };
const _hoisted_24 = {
    for: "image-file",
    class: "relative cursor-pointer text-tuk-orange hover:text-tuk-orange-dark"
};
const _hoisted_25 = {
    key: 0,
    class: "text-sm text-gray-600"
};
const _hoisted_26 = {
    key: 0,
    class: "rounded-md bg-red-50 p-4"
};
const _hoisted_27 = { class: "flex" };
const _hoisted_28 = { class: "ml-3" };
const _hoisted_29 = { class: "text-sm font-medium text-red-800" };
const _hoisted_30 = { class: "px-6 py-4 bg-gray-50 text-right space-x-3" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
    key: 0,
    class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
    fill: "none",
    viewBox: "0 0 24 24"
};
const _hoisted_34 = { class: "max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8" };
const _hoisted_35 = {
    key: 0,
    class: "flex justify-center items-center py-12"
};
const _hoisted_36 = {
    key: 1,
    class: "text-center py-12"
};
const _hoisted_37 = {
    key: 2,
    class: "space-y-4"
};
const _hoisted_38 = { class: "flex items-start" };
const _hoisted_39 = { class: "flex-shrink-0 mr-4" };
const _hoisted_40 = ["src", "alt"];
const _hoisted_41 = { class: "flex-1 min-w-0" };
const _hoisted_42 = { class: "flex items-start justify-between" };
const _hoisted_43 = { class: "flex-1 min-w-0" };
const _hoisted_44 = { class: "text-lg font-medium text-gray-900 mb-2" };
const _hoisted_45 = { class: "flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0 text-sm text-gray-500" };
const _hoisted_46 = { class: "flex items-center" };
const _hoisted_47 = { class: "flex items-center" };
const _hoisted_48 = { class: "flex items-center" };
const _hoisted_49 = { class: "flex flex-col space-y-2 ml-4" };
const _hoisted_50 = ["onClick"];
const _hoisted_51 = {
    key: 0,
    class: "w-8 h-8 sm:w-7 sm:h-7",
    fill: "currentColor",
    viewBox: "0 0 20 20"
};
const _hoisted_52 = {
    key: 1,
    class: "w-8 h-8 sm:w-7 sm:h-7",
    fill: "currentColor",
    viewBox: "0 0 20 20"
};
const _hoisted_53 = ["href", "download"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex items-center" }, [
                        _createElementVNode("img", {
                            src: _imports_0,
                            alt: "TUK Logo",
                            class: "h-6"
                        })
                    ], -1)),
                    _createElementVNode("button", {
                        class: "inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-tuk-orange hover:bg-tuk-orange-dark rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange transition-colors",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, " Log ud ")
                ])
            ])
        ]),
        (_ctx.showNewRecordingModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", {
                        class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
                        "aria-hidden": "true"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-xl text-gray-900" }, "Ny optagelse", -1)),
                                    _createElementVNode("button", {
                                        class: "text-gray-400 hover:text-gray-500",
                                        onClick: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            (...args) => (_ctx.closeNewRecordingModal && _ctx.closeNewRecordingModal(...args)))
                                    }, _cache[10] || (_cache[10] = [
                                        _createElementVNode("span", { class: "sr-only" }, "Luk", -1),
                                        _createElementVNode("svg", {
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        ], -1)
                                    ]))
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[12] || (_cache[12] = _createElementVNode("label", {
                                            for: "name",
                                            class: "block text-sm font-medium text-gray-700"
                                        }, "Navn", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            id: "name",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.newRecording.name) = $event)),
                                            type: "text",
                                            class: "shadow-sm focus:ring-tuk-orange focus:border-tuk-orange block w-full sm:text-sm border-gray-300 rounded-md p-3",
                                            placeholder: "Navn på optagelsen"
                                        }, null, 512), [
                                            [_vModelText, _ctx.newRecording.name]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        _cache[13] || (_cache[13] = _createElementVNode("label", {
                                            for: "author",
                                            class: "block text-sm font-medium text-gray-700"
                                        }, "Forfatter", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            id: "author",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.newRecording.author) = $event)),
                                            type: "text",
                                            class: "shadow-sm focus:ring-tuk-orange focus:border-tuk-orange block w-full sm:text-sm border-gray-300 rounded-md p-3",
                                            placeholder: "Forfatter"
                                        }, null, 512), [
                                            [_vModelText, _ctx.newRecording.author]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Lydfil", -1)),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mx-auto flex justify-center" }, [
                                                    _createElementVNode("svg", {
                                                        class: "h-12 w-12 text-gray-400",
                                                        stroke: "currentColor",
                                                        fill: "none",
                                                        viewBox: "0 0 48 48"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                                                            "stroke-width": "2",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                        })
                                                    ])
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("label", _hoisted_18, [
                                                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Upload lydfil", -1)),
                                                        _createElementVNode("input", {
                                                            id: "audio-file",
                                                            type: "file",
                                                            accept: ".mp3,audio/mp3",
                                                            class: "sr-only",
                                                            onChange: _cache[4] || (_cache[4] =
                                                                //@ts-ignore
                                                                (...args) => (_ctx.handleAudioFileSelect && _ctx.handleAudioFileSelect(...args)))
                                                        }, null, 32)
                                                    ]),
                                                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "pl-1" }, "eller træk og slip", -1))
                                                ]),
                                                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "MP3 op til 100MB", -1)),
                                                (_ctx.newRecording.audioFile)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Valgt fil: " + _toDisplayString(_ctx.newRecording.audioFile.name), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Billede", -1)),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mx-auto flex justify-center" }, [
                                                    _createElementVNode("svg", {
                                                        class: "h-12 w-12 text-gray-400",
                                                        stroke: "currentColor",
                                                        fill: "none",
                                                        viewBox: "0 0 48 48"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                                                            "stroke-width": "2",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                        })
                                                    ])
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("label", _hoisted_24, [
                                                        _cache[19] || (_cache[19] = _createElementVNode("span", null, "Upload billede", -1)),
                                                        _createElementVNode("input", {
                                                            id: "image-file",
                                                            type: "file",
                                                            accept: ".jpg,.jpeg,.png,image/jpeg,image/png",
                                                            class: "sr-only",
                                                            onChange: _cache[5] || (_cache[5] =
                                                                //@ts-ignore
                                                                (...args) => (_ctx.handleImageFileSelect && _ctx.handleImageFileSelect(...args)))
                                                        }, null, 32)
                                                    ]),
                                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "pl-1" }, "eller træk og slip", -1))
                                                ]),
                                                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "PNG, JPG op til 1024x1024px", -1)),
                                                (_ctx.newRecording.imageFile)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, "Valgt fil: " + _toDisplayString(_ctx.newRecording.imageFile.name), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ]),
                                    (_ctx.uploadError)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                                                    _createElementVNode("svg", {
                                                        class: "h-5 w-5 text-red-400",
                                                        viewBox: "0 0 20 20",
                                                        fill: "currentColor"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            "fill-rule": "evenodd",
                                                            d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                                            "clip-rule": "evenodd"
                                                        })
                                                    ])
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.uploadError), 1)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("button", {
                                    type: "button",
                                    disabled: _ctx.isUploading,
                                    class: "inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange",
                                    onClick: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => (_ctx.closeNewRecordingModal && _ctx.closeNewRecordingModal(...args)))
                                }, " Annuller ", 8, _hoisted_31),
                                _createElementVNode("button", {
                                    type: "button",
                                    disabled: _ctx.isUploading || !_ctx.isFormValid,
                                    class: "inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-tuk-orange border border-transparent rounded-md hover:bg-tuk-orange-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange disabled:opacity-50",
                                    onClick: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => (_ctx.uploadNewRecording && _ctx.uploadNewRecording(...args)))
                                }, [
                                    (_ctx.isUploading)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_33, _cache[25] || (_cache[25] = [
                                            _createElementVNode("circle", {
                                                class: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                "stroke-width": "4"
                                            }, null, -1),
                                            _createElementVNode("path", {
                                                class: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            }, null, -1)
                                        ])))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.isUploading ? 'Uploader...' : 'Upload'), 1)
                                ], 8, _hoisted_32)
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("main", _hoisted_34, [
            _createElementVNode("button", {
                class: "w-full mb-6 inline-flex items-center justify-center px-6 py-4 border-2 border-dashed border-gray-300 text-base font-medium rounded-lg text-gray-600 bg-white hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange transition-colors",
                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.showNewRecordingModal = true))
            }, _cache[27] || (_cache[27] = [
                _createElementVNode("svg", {
                    class: "w-6 h-6 mr-2",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                }, [
                    _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 4v16m8-8H4"
                    })
                ], -1),
                _createTextVNode(" Ny optagelse ")
            ])),
            (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[28] || (_cache[28] = [
                    _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-3 h-8 w-8 text-tuk-orange",
                        fill: "none",
                        viewBox: "0 0 24 24"
                    }, [
                        _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                    ], -1),
                    _createElementVNode("span", { class: "text-gray-600" }, "Henter optagelser...", -1)
                ])))
                : (_ctx.recordings.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[29] || (_cache[29] = [
                        _createStaticVNode("<div class=\"w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4\"><svg class=\"w-8 h-8 text-gray-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z\"></path></svg></div><h3 class=\"text-lg font-medium text-gray-900 mb-2\">Ingen optagelser endnu</h3><p class=\"text-gray-600\">Dine optagelser vil blive vist her når de er uploadet.</p>", 3)
                    ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordings, (recording) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: recording.id,
                                class: "bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow"
                            }, [
                                _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("img", {
                                            src: recording.imageUrl,
                                            alt: recording.name,
                                            class: "w-16 h-24 sm:w-20 sm:h-32 object-cover rounded-lg shadow-sm bg-gray-50",
                                            style: { "image-rendering": "-webkit-optimize-contrast", "transform": "translateZ(0)" }
                                        }, null, 8, _hoisted_40)
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("h3", _hoisted_44, _toDisplayString(recording.name || 'Unavngivet optagelse'), 1),
                                                _createElementVNode("div", _hoisted_45, [
                                                    _createElementVNode("div", _hoisted_46, [
                                                        _cache[30] || (_cache[30] = _createElementVNode("svg", {
                                                            class: "w-4 h-4 mr-1",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            viewBox: "0 0 24 24"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round",
                                                                "stroke-width": "2",
                                                                d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                            })
                                                        ], -1)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDuration(recording.duration)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_47, [
                                                        _cache[31] || (_cache[31] = _createElementVNode("svg", {
                                                            class: "w-4 h-4 mr-1",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            viewBox: "0 0 24 24"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round",
                                                                "stroke-width": "2",
                                                                d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                            })
                                                        ], -1)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(recording.createdAt)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_48, [
                                                        _cache[32] || (_cache[32] = _createElementVNode("svg", {
                                                            class: "w-4 h-4 mr-1",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            viewBox: "0 0 24 24"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round",
                                                                "stroke-width": "2",
                                                                d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                                            })
                                                        ], -1)),
                                                        _createTextVNode(" " + _toDisplayString(recording.author), 1)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_49, [
                                                _createElementVNode("button", {
                                                    class: "w-14 h-14 sm:w-12 sm:h-12 flex items-center justify-center text-white bg-tuk-orange hover:bg-tuk-orange-dark rounded-full transition-colors shadow-sm hover:shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tuk-orange",
                                                    onClick: ($event) => (_ctx.togglePlayback(recording))
                                                }, [
                                                    (!_ctx.isPlaying[recording.id])
                                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_51, _cache[33] || (_cache[33] = [
                                                            _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
                                                                "clip-rule": "evenodd"
                                                            }, null, -1)
                                                        ])))
                                                        : (_openBlock(), _createElementBlock("svg", _hoisted_52, _cache[34] || (_cache[34] = [
                                                            _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 002 0V8a1 1 0 00-1-1zm4 0a1 1 0 00-1 1v4a1 1 0 002 0V8a1 1 0 00-1-1z",
                                                                "clip-rule": "evenodd"
                                                            }, null, -1)
                                                        ])))
                                                ], 8, _hoisted_50),
                                                _createElementVNode("a", {
                                                    href: recording.audioUrl,
                                                    download: `${recording.name || 'optagelse'}.m4a`,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    class: "w-14 h-14 sm:w-12 sm:h-12 flex items-center justify-center text-gray-500 hover:text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors shadow-sm hover:shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                                }, _cache[35] || (_cache[35] = [
                                                    _createElementVNode("svg", {
                                                        class: "w-8 h-8 sm:w-7 sm:h-7",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        viewBox: "0 0 24 24"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "stroke-width": "2",
                                                            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                        })
                                                    ], -1)
                                                ]), 8, _hoisted_53)
                                            ])
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128))
                    ]))
        ])
    ]));
}
